// extracted by mini-css-extract-plugin
module.exports = {"shopping__action":"shopping_shopping__action__01eVO","counter":"shopping_counter__TNqu_"};